import { render, staticRenderFns } from "./CollegiateMatch.vue?vue&type=template&id=1386e859&scoped=true&"
import script from "./CollegiateMatch.vue?vue&type=script&lang=js&"
export * from "./CollegiateMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386e859",
  null
  
)

export default component.exports